<template>
  <div class="person-analysis" v-if="gradeList.length>0">
    <header class="p-header">
      <span class="p-title">个人学情分析</span>
    </header>
    <div >
    <header class="p-prepare-header">
      <div class="p-prepare-grade" ref="allGrade">
        <span class="grade-type p-0">年级:</span>
        <div style="flex: 1;">
          <div ref="grade">
            <span v-for="(item,i) in gradeList" :key="i"
            class="grade-type pointer"
            :class="[{'active':Number(item.grade_id)===Number(gradeId)},
            'grade-item']"
            @click="gradeClick(item)"
            >{{item.grade_name}}
            </span>
          </div>
        </div>
        <div class="grade-unfold">
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldGrade && unfoldGradeShow"
            @click="unfold('grade')"> 展开
            <i class="el-icon-caret-bottom"></i>
          </span>
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldGrade && !unfoldGradeShow"
            @click="packUp('grade')"> 收起
            <i class="el-icon-caret-top"></i>
          </span>
        </div>
      </div>
      <div class="p-prepare-class" ref="allClass">
        <span class="class-type p-0">班级:</span>
        <div style="flex: 1;">
          <div ref="class">
            <span v-for="(item,i) in classList" :key="i"
            class="class-type pointer"
            :class="[{'active':item.class_id==classId},'class-item']"
            @click="classClick(item)"
            >{{item.class_name}} </span>
            </div>
        </div>
        <div class="grade-unfold">
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldClass && unfoldClassShow"
            @click="unfold('class')"> 展开
            <i class="el-icon-caret-bottom"></i>
          </span>
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldClass && !unfoldClassShow"
            @click="packUp('class')"> 收起
            <i class="el-icon-caret-top"></i>
          </span>
        </div>
      </div>
    </header>
    <div class="person-detail">
      <div class="p-cascader">
        <el-input placeholder="输入学生名称" v-model="input" @input="inputChange"
        @keyup.enter.native="checkStudent"
        >
           <el-button slot="append" type="primary" @click="checkStudent">查询</el-button>
        </el-input>
      </div>
      <el-table
      :data="tableList.slice((currentPage-1)*pageSize,currentPage*pageSize)">
      <el-table-column
        prop="account_name"
        label="学生姓名">
      </el-table-column>
      <!-- <el-table-column
        prop="student_lately_study"
        label="最近学习的课程"
        align="center"
        >
          <template slot-scope="scope">
              {{scope.row.student_lately_study?scope.row.student_lately_study:'--'}}
          </template>
      </el-table-column> -->
      <el-table-column
        prop="last_login_time"
        label="最近活跃时间"
        align="center"
        >
        <template slot-scope="scope">
              {{scope.row.last_login_time?scope.row.last_login_time:'--'}}
          </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          width="300"
          min-width="120"
        >
        <template slot-scope="scope">
          <a @click="goDetail(scope.row)" class="go-detail">查看详情</a>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.length"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="currentPage"
      @size-change="sizeChange"
      @current-change="currentChange"
    />
    </div>
     </div>
  </div>
   <div v-else>
      <empty content="未查询到您有任教的班级," lastContent="请联系校区管理员为您分配班级" :show="false" />
    </div>
</template>

<script>
import Empty from '@/views/pt/components/empty.vue';
import { getYearClass, getStudentList } from '@/api/pt';
import { unlocking } from '@/utils/access-control';

export default {
  name: 'PersonAnalsis',
  components: {
    Empty,
  },
  mounted() {
    this.getYearClass();
  },
  data() {
    return {
      input: '', // 搜索框默认
      studentList: [], // 学生列表
      tableList: [], // 表格数据
      currentPage: 1,
      pageSize: 10,
      gradeId: null,
      classId: null,
      masterClassId: null,
      gradeList: [],
      classList: [],
      unfoldGradeShow: true,
      unfoldClassShow: true,
      unfoldClass: false,
      unfoldGrade: false,
      treeData: [],
    };
  },

  methods: {
    sizeChange(v) { // 每页条数
      this.currentPage = 1;
      this.pageSize = v;
    },
    currentChange(v) { // 当前页
      this.currentPage = v;
    },
    goDetail(row) {
      this.$router.push({
        path: '/pt/home-analysis',
        query: {
          account_id: row.account_id,
          class_id: row.class_id,
          school_id: row.school_id,
          account_name: row.account_name,
          study_day: row.study_day,
          avatar: row.avatar,
          created: row.created,
        },
      });
    },
    unfold(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = false;
        this.$refs.allGrade.style.height = `${this.$refs.grade.offsetHeight}px`;
      }
      if (type === 'class') {
        console.log(this.$refs.class.offsetHeight);
        this.unfoldClassShow = false;
        this.$refs.allClass.style.height = `${this.$refs.class.offsetHeight}px`;
      }
    },
    packUp(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = true;
        this.$refs.allGrade.style.height = '67px';
      }
      if (type === 'class') {
        this.unfoldClassShow = true;
        this.$refs.allClass.style.height = '67px';
      }
    },
    async gradeClick(item) {
      this.gradeId = item.grade_id;
      const isCharge = unlocking('Master_Sale_Manager') ? 1 : 0;
      const res = await getYearClass({
        is_charge: isCharge,
        grade_id: this.gradeId,
      });
      this.classList = res.data.class_list;
      this.classId = (this.classList[0] && this.classList[0].class_id);
      this.masterClassId = (this.classList[0] && this.classList[0].school_master_class_id);
      this.getStudentList();
    },
    classClick(item) {
      this.classId = item.class_id;
      this.masterClassId = item.school_master_class_id;
      this.getStudentList();
    },
    async getYearClass(type) {
      const isCharge = unlocking('Master_Sale_Manager') ? 1 : 0;
      const res = await getYearClass({
        is_charge: isCharge,
        grade_id: this.gradeId || 0,
      });
      this.classList = res.data.class_list;
      this.classId = this.$route.query.classId
        || (this.classList[0] && this.classList[0].class_id);
      this.masterClassId = (this.$route.query.masterClassId === 0 ? '' : this.$route.query.masterClassId)
        || (this.classList[0] && this.classList[0].school_master_class_id);
      if (!type) {
        this.gradeList = res.data.grade_list;
        this.gradeId = this.$route.query.gradeId || this.gradeList[0].grade_id;
        this.getYearClass(true);
        this.getStudentList();
      }
    },
    async getStudentList() {
      const params = {
        class_id: this.classId,
      };
      const res = await getStudentList(params);
      this.studentList = res.data;
      this.tableList = res.data;
    },
    checkStudent() {
      this.tableList = this.studentList
        .filter((item) => item.account_name.indexOf(this.input) >= 0);
    },
    inputChange(val) {
      if (val === '') {
        this.tableList = this.studentList;
      }
    },
  },
  watch: {
    gradeList() {
      this.$nextTick(() => {
        console.log(this.$refs.grade.offsetHeight, 66);
        if (this.$refs.grade && this.$refs.grade.offsetHeight < 70) {
          this.unfoldGrade = true;
        } else {
          this.unfoldGrade = false;
        }
      });
    },
    classList() {
      this.$nextTick(() => {
        if (this.$refs.class && this.$refs.class.offsetHeight < 70) {
          this.unfoldClass = true;
        } else {
          this.unfoldClass = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.person-analysis{
  background-color: #fff;
  .p-header{
    height: 85px;
    line-height: 95px;
    border-bottom: 1px solid #EBEEF5;

    .p-title{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-left: 39px;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        bottom: 3px;
        left: 0;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 5px;
        left: -9px;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
      }
    }
  }
  .person-detail{
    padding:21px 23px 30px 28px;
    .p-list{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1989FA;
    }
        .p-cascader{
      margin-top: 20px;
      margin-bottom: 40px;
      display: flex;
       /deep/{
      .el-input:first-child{
        width: 298px;
        height: 40px;
        margin-right:32px ;
      }
      .el-input:last-child{
        width: 328px;
        height: 40px;
      }
      .el-input-group__append{
        border: none;
      }
      .el-button{
        background-color: #1989FA;
        font-weight: 500;
        color: #FFFFFF;
        font-size: 15px;
      }
    }
    }
    /deep/ {
      .el-table{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #606266;
        .el-table__header th {
          background-color: #F0F2F5;
        }
      }
      .el-pagination {
      margin-top: 20px;
      display: flex;
      width: calc(100% - 64px);
      & .btn-prev {
        margin-left: auto;
      }
    }
    }
    .go-detail{
      font-weight: 500;
      color: #1989FA;
      cursor: pointer;
    }

  }
}
.p-prepare{

   &-header{
       padding: 0px 25px 0 25px;
    border-bottom:8px solid #EEF2F9FF ;
    .p-0 {
    padding: 0 12px !important;
  }
    .p-prepare-grade{
      display: flex;
      overflow: hidden;
      height: 67px;
      width: 100%;
      line-height: 67px;
      border-bottom:1px dashed #DCE1EB ;
      .grade-type{
        padding: 7px 12px;
        font-size: 16px;
        color: #000000;
        margin-right:20px ;
      }
      .grade-circle{
         width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
      }
    }
     .grade-unfold {
        width: 105px;
        color: rgba(25, 137, 250, 1);
      }
    .p-prepare-class{
       display: flex;
       overflow: hidden;
      min-height: 67px;
      width: 100%;
      line-height: 67px;
      .class-type{
        padding: 7px 12px;
        font-size: 16px;
        color: #000000;
        margin-right:20px ;
      }
    }
    .grade-item, .class-item {
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
     .active{
      border-radius: 5px;
      background-color: rgba(25, 137, 250, 1);
      color: #fff !important;
      font-weight: 500;
      &:hover {
        color: #fff !important;
      }
    }
   }

  }
</style>
